import type { EnvironmentConfig } from '@luna/env';
import { getEnv } from '@luna/env';

export function getAttachmentUrl(transactionId: string): string {
    const { georgeApiUrl } = getEnv<EnvironmentConfig>();
    return `${georgeApiUrl}my/transactions/${transactionId}/attachment`;
}
